import * as React from "react";
import { useModalContext } from "common/contexts";
import { useTriggerSecurityEventNotification } from "security-app/hooks/useSecurityEventsAPI";
import SendNotificationModal from "security-app/components/SecurityEvents/Alerts/AlertsModals/NotificationsModal/SendNotificationModal";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
function SendNotification() {
  const { entity: securityEvent, setEntity, setModal } = useModalContext();
  const { triggerSecurityEventNotification, triggeringSecurityEventNotification } = useTriggerSecurityEventNotification();
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const closeModal = () => {
    setModal(null);
    setEntity(null);
  };
  const onConfirm = async (notificationId) => {
    await triggerSecurityEventNotification({ id: securityEvent.event_id, notificationId });
    sendEventActionTelemetry("SEND_NOTIFICATION", false);
    setModal(null);
    setEntity(null);
  };
  return /* @__PURE__ */ React.createElement(
    SendNotificationModal,
    {
      confirmDisabled: triggeringSecurityEventNotification,
      closeModal,
      onConfirm
    }
  );
}
export default SendNotification;
